module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/planning/land-record/land-record.component.css
// module id = ./src/app/planning/land-record/land-record.component.css
// module chunks = main